import { Theme, createStyles } from "@material-ui/core";

export const styles = (theme: Theme) =>
  createStyles({
    appBar: {
      [theme.breakpoints.up("md")]: {
        width: `calc(100% - ${theme.drawer.width}px)`,
        marginLeft: theme.drawer.width,
      },
      color: theme.palette.primary.main,
      boxShadow: "none",
      backgroundColor: "white",
    },
    toolbar: {
      backgroundColor: "#FAFAFA",
      borderRadius: "30px 0px 0px 30px",
      [theme.breakpoints.down("xs")]: {
        backgroundColor: "white",
      },
    },
    menuButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("md")]: {
        display: "none",
      },
      [theme.breakpoints.down("xs")]: {
        marginRight: theme.spacing(1),
      },
    },
    toolbarRightContent: {
      display: "flex",
      width: "100%",
      padding: "10px 0",
      [theme.breakpoints.down("xs")]: {
        width: "87%",
      },
    },
    titulo: {
      fontSize: 34,
      margin: 0,
      fontWeight: "normal",
      [theme.breakpoints.down("xs")]: {
        fontSize: 21,
      },
    },
    date: {
      fontSize: 16,
      color: "#3b4609",
    },
    logout: {
      marginLeft: 30,
      cursor: "pointer",
    },
    btnShadowNone: {
      backgroundColor: "transparent",
      "&:hover": {
        backgroundColor: "transparent",
      },
    },
  });
